module.exports = __webpack_public_path__ + "img/illu-cloud.77fdb292.svg";